/* nice-try/src/index */ function _(require, module, exports) {
    /**
     * Tries to execute a function and discards any error that occurs.
     * @param {Function} fn - Function that might or might not throw an error.
     * @returns {?*} Return-value of the function when no error occurred.
     */
    module.exports = function (fn) {
        try {
            return fn();
        }
        catch (e) { }
    };
}
